import React from 'react';
import { Panel, Button } from 'react-bootstrap';
import LoadingPlaceholder from './../../shared/LoadingPlaceholder';

import { connect } from 'react-redux';
import { getTranslate, getActiveLanguage } from 'react-localize-redux';

import moment from 'moment';

import './summary.scss';

const ticketImage = require('./../../../images/ticket.png');

class Summary extends React.Component {

  constructor(props) {
    super(props);
  }

  render() {
    moment.locale(this.props.currentLanguage);

    const loadingSpinner = (
      <p className="text-center">
        <i className="fa fa-ellipsis-h fa-2x fa-fw"></i>
      </p>
    );

    const summaryHeader = (
      <div className="summary-component__header">
        <p className="text-center"><img src={ticketImage} alt="Summary" /></p>
        <LoadingPlaceholder ready={!this.props.loading}>
          <h5 className="summary-component__name"><strong>{this.props.firstName} {this.props.lastName}</strong></h5>
          <h6 className="summary-component__reservation-number">{this.props.translate('welcome.summary.reservation_number')} {this.props.reservationNumber}</h6>
        </LoadingPlaceholder>
      </div>
    );

    const checkinOnlineButton = (
      <Button href={this.props.checkInOnlineLink} target="_blank" block>{this.props.translate('welcome.summary.do_check_in_button')}</Button>
    );

    const checkinOnlineRow = (
      <div className="summary-component__row">
      <div className="summary-component__check-in-now-table">
        <div className="summary-component__check-in-now-cell">
          <h4>Check-In Online</h4>
          <p>{ this.props.checkInOnlineDone ? this.props.translate('welcome.summary.checked_in') : this.props.translate('welcome.summary.not_checked_in') }</p>
          { this.props.checkInOnlineDone ? null : checkinOnlineButton }
        </div>
      </div>
    </div>
    );

    const checkInDateTime = moment.unix(this.props.checkInDate).utcOffset(this.props.utcOffset);
    const checkOutDateTime = moment.unix(this.props.checkOutDate).utcOffset(this.props.utcOffset);

    return (
      <Panel className="summary-component" header={summaryHeader}>
        <div className="summary-component__row">
          <LoadingPlaceholder ready={!this.props.loading}>
            <h4>Check-In</h4>
            <p>{this.props.translate('welcome.summary.check_in', {date: checkInDateTime.format('LL'), time: checkInDateTime.format('LT')})}</p>
          </LoadingPlaceholder>
        </div>
        <div className="summary-component__row">
          <LoadingPlaceholder ready={!this.props.loading}>
            <h4>Check-Out</h4>
            <p>{this.props.translate('welcome.summary.check_out', {date: checkOutDateTime.format('LL'), time: checkOutDateTime.format('LT')})}</p>
          </LoadingPlaceholder>  
        </div>

        {this.props.checkInOnlineEnabled ? checkinOnlineRow : null }
      </Panel>
    );
  }
}

Summary.displayName = 'PagesWelcomeSummary';
Summary.propTypes = {};
Summary.defaultProps = {};

const mapStateToProps = (state) => {
  return { 
    translate: getTranslate(state.locale),
    currentLanguage: getActiveLanguage(state.locale).code,
    firstName: state.reservation.apiData.first_name,
    lastName: state.reservation.apiData.last_name,
    reservationNumber: state.reservation.apiData.id,
    checkInDate: state.reservation.apiData.checkin_date,
    checkOutDate: state.reservation.apiData.checkout_date,
    checkInOnlineEnabled: (state.reservation.apiData.checkin_online || {}).enabled,
    checkInOnlineDone: (state.reservation.apiData.checkin_online || {}).done,
    checkInOnlineLink: (state.reservation.apiData.checkin_online || {}).link,
    utcOffset: parseInt(state.reservation.apiData.utc_displacement) || 0,
    loading: state.reservation.loading
  };
};

export default connect(mapStateToProps)(Summary);



// WEBPACK FOOTER //
// ./components/pages/welcome/Summary.js